import React from 'react'

const Skills = () => {
  return (
    <div>
    <div className='hidden md:flex'>
    <div className='absolute  top-[3100px]  w-full  text-center  font-poppins  justify-center '>
        
        <div className='space-y-10'>
        <h1 className='text-7xl text-bold'>Skills</h1>
        <button className='text-xl flex-col text-center  p-10  bg-slate-200 rounded-2xl shadow-black shadow-2xl'>
<img className='object scale-50' src="logo" alt="" />
         <h1>Communication</h1>
         <h1>Problem Solving</h1>
         <h1>Creativity</h1>
         <h1>Collaborative</h1> 

        </button>
        </div>
       </div>
       </div>

       

       <div className=' md:hidden'>
    <div className='absolute  top-[3100px]  w-full  text-center  font-poppins  justify-center '>
        
        <div className='space-y-10'>
        <h1 className='text-3xl text-left text-bold'>Skills</h1>
        <button className='text-xl flex-col text-center  p-10 w-full justify-center  bg-slate-200 rounded-2xl shadow-black shadow-2xl'>

         <h1>Communication</h1>
         <h1>Problem Solving</h1>
         <h1>Creativity</h1>
         <h1>Collaborative</h1> 

        </button>
        </div>
       </div>
       </div>
       </div>

  )
}

export default Skills